import { Action, Select, Selector, State, StateContext } from "@ngxs/store";
import { UserInterfaceStateModel } from "./ui-model";
import { ActivatedRoute, Router } from "@angular/router";
import { EncounterService } from "../../services/encounter.service";
import { Injectable } from "@angular/core";
import { Encounters } from "../encounters/encounter-actions";
import { UserInterface } from "./ui-actions";




@State<UserInterfaceStateModel>
(
    {
        name: "userInterface",
        defaults: 
        {
            sidebarVisible: false,
            claimTrayOpen: false,
            encounterStatuses: [],
            showTopMenu: true
        }
    }
)

@Injectable()
export class UserInterfaceState
{
    constructor
    (
        private router: Router,
        private route: ActivatedRoute,
        private _encounters: EncounterService
    )
    {

    }

    @Selector()
    static sidebarVisibility(state: UserInterfaceStateModel) 
    {
      return state.sidebarVisible;
    }

    @Selector()
    static encounterStatuses(state: UserInterfaceStateModel)
    {
        return state.encounterStatuses;
    }

    @Selector()
    static topMenuVisibility(state: UserInterfaceStateModel)
    {
        return state.showTopMenu;
    }

    @Action([UserInterface.SetTopMenuVisibility])
    setTopMenuVisibility(ctx: StateContext<UserInterfaceStateModel>, action: UserInterface.SetTopMenuVisibility)
    {
        const state = ctx.getState();

        ctx.setState
        (
            {
                ...state,
                showTopMenu: action.payload.show
            }
        )
    }

    @Action([UserInterface.LoadRouteInSidebar])
    loadRouteInSidebar(ctx: StateContext<UserInterfaceStateModel>, action: UserInterface.LoadRouteInSidebar)
    {
        this.router.navigate([{ outlets: { sidebar: [action.payload.route] } }],{relativeTo:this.route})
        this.showSidebar(ctx);
    }

    @Action([UserInterface.CloseSidebar])
    closeSidebar(ctx: StateContext<UserInterfaceStateModel>)
    {
        this.router.navigate([''],{replaceUrl:true});
        this.hideSidebar(ctx);
    }

    @Action([UserInterface.OpenSidebar])
    openSidebar(ctx: StateContext<UserInterfaceStateModel>)
    {
        this.showSidebar(ctx);
    }

    @Action([Encounters.EncounterOpenedFromEncounterManager])
    encounterOpened(ctx:StateContext<UserInterfaceStateModel>)
    {
        this.router.navigate([''],{replaceUrl:true});
        this.hideSidebar(ctx);
    }

    showSidebar(ctx:StateContext<UserInterfaceStateModel>)
    {
        const state = ctx.getState();

        ctx.setState
        (
            {
                ...state,
                sidebarVisible: true
            }
        )
    }

    hideSidebar(ctx:StateContext<UserInterfaceStateModel>)
    {
        const state = ctx.getState();

        ctx.setState
        (
            {
                ...state,
                sidebarVisible: false
            }
        )
    }
}   